module.exports = __webpack_public_path__ + "img/files-color.190419ff.svg";